import type { Vue } from 'vue/types/vue';
import { nextTick } from 'vue';
import posthog from 'posthog-js';
import type { PostHog } from 'posthog-js';

const POSTHOG_API_HOST = 'https://eu.posthog.com';
let postHogClient: PostHog | undefined;

export default {
  install(Vue: Vue, options: Record<string, any>) {
    if (process.env.VUE_APP_POSTHOG_API_KEY) {
      postHogClient = posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
        api_host: POSTHOG_API_HOST,
        capture_pageview: false,
      });

      options.router.afterEach(() => {
        nextTick(() => {
          postHogClient?.capture('$pageview');
        });
      });
    }
  },
};

export function getPostHog(): PostHog | undefined {
  return postHogClient;
}
